import { initializeMetaMeasurement, measurePreviewEvent } from '../services/metaConversionService';
import { rememberMarketingTouch } from '../services/marketingAttributionService';
import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BlissPurchaseJourney from "../components/bliss/BlissPurchaseJourney";
import "../components/bliss/design/BlissDesignConfiguratorShell.css";
const SharedStudioLook = lazy(() =>
  import("../components/bliss/design/studio/StudioSharing").then((m) => ({
    default: m.SharedStudioLook,
  })),
);
export default function BlissDesignConfigurator() {
  useEffect(() => {
    rememberMarketingTouch();
    try { initializeMetaMeasurement(); measurePreviewEvent('landing_view'); }
    catch { /* A blocked tracker must not interrupt the room preview. */ }
  }, []);
  const share = new URLSearchParams(useLocation().search).get("share");
  if (share)
    return (
      <Suspense fallback={<p>Opening your shared look…</p>}>
        <SharedStudioLook token={share} />
      </Suspense>
    );
  return <BlissPurchaseJourney />;
}
